import * as React from "react";
import {
  SettingsIcon,
  DownloadIcon,
  SearchIcon,
  EditIcon,
  X,
} from "lucide-react";
import InfoTooltip from "./InfoTooltip";
import { ErrorBoundary } from "react-error-boundary";
import { WidgetProps } from "./CommonTypes";

const CustomWidget: React.FC<WidgetProps> = ({
  title = "",
  children,
  settings = false,
  download = false,
  downloadUrl = "",
  info = "",
  className = "",
  detailButton = false,
  onDetailClick = () => {},
  customOptions,
  onEditClick,
}) => {
  const [editing, setEditing] = React.useState(false);

  function clickEdit() {
    setEditing(!editing);
    if (onEditClick) {
      onEditClick();
    }
  }

  return (
    <>
      <div
        className={
          "bg-primary-background CUSTOM_LS_WIDGET flex flex-col " + className
        }
      >
        <div className="w-full flex justify-end gap-[2px] items-center">
          {customOptions ? customOptions : null}
          {onEditClick && editing == false ? (
            <div
              className={`p-2 border-background bg-secondary cursor-pointer`}
              onClick={clickEdit}
            >
              <EditIcon size={14} />
            </div>
          ) : null}
          {onEditClick && editing ? (
            <div
              className={`p-2 border-background bg-secondary cursor-pointer`}
              onClick={clickEdit}
            >
              <X size={14} />
            </div>
          ) : null}
          {detailButton && (
            <div
              onClick={onDetailClick}
              className={`p-2 border-background bg-secondary cursor-pointer`}
            >
              <SearchIcon size={14} />
            </div>
          )}
          {settings && (
            <div
              className={`p-2 border-background bg-secondary cursor-pointer`}
            >
              <SettingsIcon size={14} />
            </div>
          )}
          {download && (
            <div
              className={`p-2 border-background bg-secondary cursor-pointer`}
            >
              <DownloadIcon
                size={14}
                onClick={() => window.open(downloadUrl, "_blank")}
              />
            </div>
          )}
          <div
            className={`cursor-pointer p-2 bg-secondary ${info && info.toString().length > 0 ? "" : "hidden"}`}
          >
            <InfoTooltip text={info} />
          </div>
        </div>
        <div className="px-6 py-2 flex flex-1 flex-col">
          <div className="text-sm font-bold mb-2 widgetTitle">{title}</div>
          <div className="flex-1">
            <ErrorBoundary
              fallback={<div>Something went wrong!</div>}
              onError={(err) => console.log(err)}
            >
              {children}
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomWidget;
